import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
declare var $;
@Component({
  selector: 'app-sw-add-resource',
  templateUrl: './sw-add-resource.component.html',
  styleUrls: ['./sw-add-resource.component.css']
})
export class SwAddResourceComponent implements OnInit {
  // 确认删除弹框
  @ViewChild("trim") trim: SwMassageConfirmComponent;

  @Input() state:string

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(){
    if(this.state == 'addResource'){
      $('.addResourceBox').css('right','0');
    }else{
      $('.addResourceBox').css('right','-510px');
    }
  }

  // 执行关闭操作，需关闭右侧弹出框
  componentStateChange(event){
    $('.addResourceBox').css('right','-510px');
  }
}
